import { IVariablesContext } from 'components/MCTextEditor/MCEditorContextInterfaces'

import { deleteVariable } from './deleteVariable'
import { createInsertVariable } from './insertVariable'
import { readonlyVariable } from './readonlyVariable'
import { selectVariable } from './selectVariable'
import { createUpdateVariable } from './updateVariable'

export const createVariableMiddlewares = (context: IVariablesContext) => {
  const withSuggestions = !context.config.json
  return [
    ...(withSuggestions ? [createInsertVariable(context.getFields)] : []),
    readonlyVariable,
    selectVariable,
    deleteVariable,
    createUpdateVariable(context.getLabelById),
  ]
}
